import businessClient from 'src/services/clients/business'
import { IMeta, IUnit } from 'src/common/interfaces/index.js'

const ISettingsUnitListResponse = { meta: IMeta, data: { list: [IUnit] } }

export const settingsUnit = {
  /**
   * @param {id: number} filter
   * @return {Promise<ISettingsUnitListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('units/portal/list', { filter }, { signal })
  },
  /**
   * @param {IUnit} data
   * @return {Promise<{upsert: [IUnit]}>}
   */
  upsert(data, signal) {
    return businessClient().post('units/upsert', { data }, { signal })
  },
  /**
   * @param { id: number} filter
   * @return {Promise<IUnit>}
   */
  archive(filter, signal) {
    return businessClient().post('units/archive', { filter }, { signal })
  },
}
